import { BaseService } from "./base.service";
import axios from 'axios';

class StatisticService extends BaseService{

    async getJobsDone(from:string,to:string){
        return axios.get(`${this.api}statistic/job/done/?from=${from}&to=${to}`).then(req => { return req.data; });
    }

    async getJobsAssigned(from:string,to:string){
        return axios.get(`${this.api}statistic/job/assigned/?from=${from}&to=${to}`).then(req => { return req.data; });
    }

    async getJobsMoved(from:string,to:string){
        return axios.get(`${this.api}statistic/job/moved/?from=${from}&to=${to}`).then(req => { return req.data; });
    }

    async getDashboardSummary(companyId:string){
        const result = await axios.get(`${this.api}statistic/GetDashboardSummary?companyId=${companyId}`);
        return result.data;
    }

    async getAssignedJobsChartDataStatistics(query:any){
        const result = await axios.post(`${this.api}statistic/GetAssignedJobsChartDataStatistics`, query);
        return result.data;
    }

    async getJobSummaryStatistic(query:any){
        const result = await axios.post(`${this.api}statistic/GetJobSummaryStatistic`,query );
        return result.data;
    }

    async getJobStatisticList(query:any){
        const result = await axios.post(`${this.api}statistic/GetJobStatisticList`,query );
        return result.data;
    }

    async getJobStatisticListFile(query:any){
        const result = await axios.post(`${this.api}statistic/GetJobStatisticListFile`,query, {
            responseType: "blob",
            timeout: 3000000000,
          } );
        return result.data;
    }

    async getStatisticsInformationOnClass(className:string){
        const result = await axios.get(`${this.api}statistic/GetStatisticsInformationOnClass?className=${className}`);
        return result.data;
    }
}


export const statisticService = new StatisticService();